import React from 'react';
import { useSafeTranslation } from '../hooks/useSafeTranslation';
import InventoryPotionSprite, { xpPotionSpriteSizeFromBonusPercent } from './InventoryPotionSprite';

export interface XpPotionBonusResultLineProps {
  bonusAmount: number;
  bonusPercent: number;
}

/**
 * Shared XP potion bonus row (solo quiz results + PvP results breakdown).
 */
const XpPotionBonusResultLine: React.FC<XpPotionBonusResultLineProps> = ({ bonusAmount, bonusPercent }) => {
  const { t } = useSafeTranslation();
  if (bonusAmount <= 0) return null;

  return (
    <div className="mt-1 d-inline-flex align-items-center justify-content-center flex-wrap gap-2 w-100">
      <InventoryPotionSprite
        variant="experience"
        size={xpPotionSpriteSizeFromBonusPercent(bonusPercent)}
        frameDisplayPx={22}
        className="flex-shrink-0"
      />
      <small className="text-primary-emphasis mb-0">
        {t('quiz.xpPotionBonusXP', 'XP potion bonus (+{{pct}}%): +{{xp}} XP')
          .replace('{{pct}}', String(bonusPercent))
          .replace('{{xp}}', String(bonusAmount))}
      </small>
    </div>
  );
};

export default XpPotionBonusResultLine;
